import CardsList from "@/components/cardsList";
import { LBGhoverEffect } from "styles/hoverPresets";
import { SOLUTIONS_CONSTANTS } from "./constants";

const Solutions = () => {
  return (
    <CardsList
      {...SOLUTIONS_CONSTANTS}
      columns={{ base: 1, sm: 3 }}
      spacing={{ base: 8, md: 12 }}
      hoverEffect
      hover={LBGhoverEffect}
    />
  );
};

export default Solutions;
